const fields = [
    { field: 'password', type: 'password', placeholder: 'Password', label: 'Password'},
    { field: 'confirmPassword', type: 'passwordConfirm', placeholder: 'Confirm Password', label: 'Confirm Password', customValidator: 'confirmPassword' }
];

export const PasswordFormFieldsConfig = fields.map(x => {
    return {
        field: x.field,
        edit: {
            enabled: true,
            type: x.type,
            htmlAttributes: {
                placeholder: x.placeholder
            },
            name: x.label,
            label: x.label, //getStorageFieldLabel(x.field) ||
            editable: true
            ,
            rules: {
                required: {
                    value: true,
                    message: `${x.label} is required.`
                },
                minLength: {
                    value: 8,
                    message: `Password should be at least 8 characters`,
                },
                pattern: {
                    value: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!$%&*#?@^]).+$/,
                    message: `Password should be alpha-numeric containing at least one special character and one upper case letter`,
                  },
                
                
                customValidator: x.customValidator,

            }
        }
    }
})